// 1.3.7.异议类型枚举
export const YYLX = [
	{
		value:'ESSENTIAL_INFO',
		text:'基本信息'
	},
	{
		value:'EXAMINATION_INFO',
		text:'报考信息'
	},
	{
		value:'FEE_INFO',
		text:'缴费信息'
	}
];

// 1.3.7.异议状态枚举
export const YYZT = [
	{
		value:'PENDING',
		text:'待处理'
	},
	{
		value:'REJECT',
		text:'不予处理'
	},
	{
		value:'IN_PROCESS',
		text:'处理中'
	},
	{
		value:'COMPLETE',
		text:'完成'
	}
];

// 1.3.7.异议状态枚举
export const YYZT_MAP = 
{
	'PENDING' : '待处理',
	'REJECT' : '不予处理',
	'IN_PROCESS' : '处理中',
	'COMPLETE' : '完成',

}
// 1.3.9.联系方式枚举
export const LXFS = [
	{
		value:'CALL',
		text:'呼叫'
	},
	{
		value:'QQ',
		text:'QQ'
	},
	{
		value:'WECHAR',
		text:'微信'
	},
	{
		value:'VISIT',
		text:'拜访'
	},
	{
		value:'SHORT_MESSAGE',
		text:'短信'
	},
	{
		value:'OTHER',
		text:'其他'
	},

];
//学历类型  //意向转考生
export const XL = [
	{
		value:'XIAOXUE',
		text:'小学'
	},
	{
		value:'CHUZHONG',
		text:'初中'
	},
	{
		value:'GAOZHONG',
		text:'高中'
	},
	{
		value:'JIXIAO',
		text:'技校'
	},
	{
		value:'GAOJI',
		text:'高技'
	},
	{
		value:'ZHIGAO',
		text:'职高'
	},
	{
		value:'DAZHUNAN',
		text:'大专'
	},
	{
		value:'DAXUE',
		text:'大学'
	}
	,{
		value:'BENKE',
		text:'本科'
	},
	{
		value:'SHUOSHI',
		text:'硕士'
	},
	{
		value:'BOSHI',
		text:'博士'
	},
	{
		value:'ZHONGZHUNAN',
		text:'中专'
	},
	{
		value:'QITA',
		text:'其他'
	}
];
//学历类型
export const EducationType = [
	{
		value:'ZXKS',
		text:'自学考试'
	},
	{
		value:'CRJY',
		text:'成人教育'
	},
	{
		value:'WLJY',
		text:'网络教育'
	},
	{
		value:'GJKFDX',
		text:'国家开放大学'
	},
	{
		value:'PTZSB',
		text:'普通专升本'
	},
	{
		value:'ZYZGZS',
		text:'职业资格证书'
	}
];

// 注册信息查询  审核状态枚举
export const checkType = [
	{
		value:'WAIT',
		text:'等待审核'
	},
	{
		value:'PASS',
		text:'通过'
	},
	{
		value:'NOT_PASS',
		text:'不通过'
	}
];

// 注册信息查询  审核状态枚举
export const checkTypeMap = {
	'WAIT':'等待审核',
	'PASS':'通过',
	'NOT_PASS':'不通过',
};
// 考生注册表审核状态枚举
export const KSZCBSHZT = [
	{
		value:'PASS',
		text:'通过'
	},
	{
		value:'NOT_PASS',
		text:'未通过'
	}
];

//联系时间
export const relationTime = [
	{
		value:3,
		text:'近三天'
	},
	{
		value:7,
		text:'近一周'
	},
	{
		value:30,
		text:'近一个月'
	},
	{
		value:90,
		text:'近三个月'
	}
];

//关系等级
export const RelationHierarchy = [
	{
		value:'COMMONLY',
		text:'一般'
	},
	{
		value:'DIFFERENCE',
		text:'较差'
	},
	{
		value:'GOOD',
		text:'较好'
	},
	{
		value:'VERY_GOOD',
		text:'极好'
	}
];

//客户阶段
export const TrackStatus = [
	{
		value:'COMMUNICATION',
		text:'沟通中'
	},
	{
		value:'TURN_EXAMINEE',
		text:'转考生'
	},
	{
		value:'DEAL',
		text:'已成交'
	},
	{
		value:'OUT_OF_CONTACT',
		text:'联系不上'
	},
	{
		value:'LOSS',
		text:'已流失'
	}
];
// 重要程度
export const Importance = [
	{
		value:'COMMONLY',
		text:'一般'
	},
	{
		value:'IMPORTANT',
		text:'重要'
	},
	{
		value:'VERY_IMPORTANT',
		text:'非常重要'
	},
	{
		value:'EXTREMELY_IMPORTANT',
		text:'极其重要'
	},
	{
		value:'NOT_IMPORTANCE',
		text:'不重要'
	}
];

//客户来源
export const CustomerSource = [
	{
		value:'INDEPENDENT',
		text:'独立开发'
	},
	{
		value:'BUILD_COLLEGE_HAlf',
		text:'建立院校(半服)'
	},
	{
		value:'BUILD_COLLEGE_ALL',
		text:'建立院校(全服务)'
	},
	{
		value:'PHONE_VISIT',
		text:'电话来访'
	},
	{
		value:'WECHAT_CONSULT',
		text:'微信咨询'
	},
	{
		value:'CHANNEL_INTRODUCE',
		text:'渠道介绍'
	},
	{
		value:'STUDENT_INTRODUCE',
		text:'学生介绍'
	},
	{
		value:'SCHOOL_REGISTRATION',
		text:'网校注册'
	},
	{
		value:'CUSTOMER_INTRODUCE',
		text:'客户介绍'
	},
	{
		value:'QQ',
		text:'QQ咨询'
	},
	{
		value:'BIG_DATA',
		text:'大数据'
	},
	{
		value:'ONLINE_RETAILER',
		text:'电商'
	}
];
// 收费类型
export const sflx = [
	{
		value:'ZK_ONE',
		text:'自考第一年学费'
	},
	{
		value:'ZK_TWO',
		text:'自考第二年学费'
	},
	{
		value:'ZK_THREE',
		text:'自考第三年学费'
	},
	{
		value:'APPLICATION_FEE',
		text:'报考费'
	},
	{
		value:'ONLINE_LEARNING_FEE',
		text:'网络学习费'
	},
	{
		value:'APPLICATION_FEE',
		text:'报考费'
	},
	{
		value:'PAPER',
		text:'论文答辩费'
	},
	{
		value:'TEXTBOOK',
		text:'教材费'
	},
	{
		value:'PRACTICE_COURSE',
		text:'实践考核费'
	}
];


//学历类型
export const xllx = [
	{
		value:'ZXKS',
		text:'自学考试' 

	},
	{
		value:'CRJY',
		text:'成人教育'
	},
	{
		value:'WLJY',
		text:'网络教育' 
	},
	{
		value:'GJKFDX',
		text:'国家开放大学'
	},
	{
		value:'PTZSB',
		text:'普通专升本'
	},
	{
		value:'ZYZGZS',
		text:'职业资格证书'
	}
];
//学历类型
export const xllx_map = {
	'ZXKS':'自学考试',
	'CRJY':'成人教育',
	'WLJY':'网络教育',
	'GJKFDX':'国家开放大学',
	'PTZSB':'普通专升本',
	'ZYZGZS':'职业资格证书'
};
//套餐限制类型
export const xzlx = [
	{
		value:'REG_BATCH',
		text:'注册批次'
	},
	{
		value:'ENROLLMENT_POINT',
		text:'招生点'
	},
	{
		value:'REG_POINT',
		text:'注册点'
	},
	{
		value:'CLASS',
		text:'班级'
	}
];
//专业层次
export const zycc = [
	{
		value:'A',
		text:'专科'
	},
	{
		value:'B',
		text:'本科'
	},
	{
		value:'C',
		text:'高起本'
	}
];
export const zycc_map ={
		A:'专科',
		B:'本科',
		C:'高起本'
	};
//开考类型
export const kklx = [{"value":"NONE","text":"无"},{"value":"SOCIETY","text":"面向社会开考"},{"value":"INDUSTRY","text":"行业部门委托开考"},{"value":"FULLTIME_STUDY","text":"全日制助学班"},{"value":"A_JOIN","text":"专科衔接教育"},{"value":"B_JOIN","text":"本科衔接教育"},{"value":"SECOND_EDU","text":"第二学历"},{"value":"SOCIETY_BACKUP","text":"社会备案制"},{"value":"A_BASE_B","text":"专起本"},{"value":"STUDY","text":"全日制"},{"value":"NO_STUDY","text":"非全日制"},{"value":"STUDY_A","text":"全日制专科"},{"value":"STUDY_B","text":"全日制专升本"},{"value":"STUDY_C","text":"全日制本科(专本连读)"},{"value":"NO_STUDY_A","text":"非全日制专科"},{"value":"NO_STUDY_B","text":"非全日制专升本"},{"value":"NO_STUDY_TOWB","text":"非全日制本科(第二学历学位)"},{"value":"CRJY_A","text":"成人教育专科"},{"value":"CRJY_B","text":"成人教育本科"},{"value":"CRJY_C","text":"成人教育高起本"},{"value":"WLJY_A","text":"网络教育专科"},{"value":"WLJY_B","text":"网络教育本科"},{"value":"WLJY_C","text":"网络教育高起本"},{"value":"GJKF_A","text":"国家开放大学专科"},{"value":"GJKF_B","text":"国家开放大学本科"}]
export const kklx_map = {"STUDY_B":"全日制专升本","SOCIETY_BACKUP":"社会备案制","NONE":"无","NO_STUDY_TOWB":"非全日制本科(第二学历学位)","STUDY_C":"全日制本科(专本连读)","GJKF_A":"国家开放大学专科","B_JOIN":"本科衔接教育","SOCIETY":"面向社会开考","CRJY_A":"成人教育专科","GJKF_B":"国家开放大学本科","NO_STUDY":"非全日制","FULLTIME_STUDY":"全日制助学班","INDUSTRY":"行业部门委托开考","NO_STUDY_B":"非全日制专升本","WLJY_C":"网络教育高起本","CRJY_B":"成人教育本科","A_BASE_B":"专起本","WLJY_B":"网络教育本科","SECOND_EDU":"第二学历","WLJY_A":"网络教育专科","A_JOIN":"专科衔接教育","STUDY_A":"全日制专科","STUDY":"全日制","CRJY_C":"成人教育高起本","NO_STUDY_A":"非全日制专科"};
//课程类型
export const kclx_map = {
	'1':'公共基础课',
	'2':'专业核心课',
	'3':'选考课程'
};
export const register_status =  [
		{value:'UNREGISTERED_UNPAID','text':'未注册/待缴费'},  //预注册0
		{value:'READING',text:'在读'},
		{value:'CAN_APPLY_GRADE',text:'可申请毕业'},
		{value:'GRADUATED',text:'已毕业'},
		{value:'SUSPENDED',text:'休学'},
		{value:'DROP_OUT',text:'退学'},
		{value:'TRANSFER',text:'转学'},
		{value:'REGISTERED_UNPAID',text:'未注册/已缴费'},
		{value:'REGISTERED',text:'已注册'}
];
export const register_status_map =  {
		'UNREGISTERED_UNPAID':'未注册/待缴费',  //预注册0
		'READING':'在读',
		'CAN_APPLY_GRADE':'可申请毕业',
		'GRADUATED':'已毕业',
		'SUSPENDED':'休学',
		'DROP_OUT':'退学',
		'TRANSFER':'转学',
		'REGISTERED_UNPAID':'未注册/已缴费',
		'REGISTERED':'已注册'
};
//考生信息可变更字段枚举
export const zcxx_update_filed =  [
		{value:'NAME','text':'姓名'},
		{value:'GENDER',text:'性别'},
		{value:'SFZH',text:'身份证号'},
		{value:'SJH',text:'手机号'},
		{value:'ZKXX',text:'主考学校'},
		{value:'ZXJG',text:'助学机构'},
		{value:'SPECIALTY',text:'专业'}
];
export const zcxx_update_filed_map =  {
		'NAME':'姓名',
		'GENDER':'性别',
		'SFZH':'身份证号',
		'SJH':'手机号',
		'ZKXX':'主考学校',
		'ZXJG':'助学机构',
		'SPECIALTY':'专业'
};




